<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect width="40" height="40" fill="none" />
    <rect
      v-for="(rect, i) in rects"
      :key="i"
      v-if="triggered[i] || isFadingOut"
      :class="[rect.dir, { enter: triggered[i], fadeout: isFadingOut }]"
      :x="rect.x"
      :y="rect.y"
      :width="rect.w"
      :height="rect.h"
      :fill="rect.fill"
    />
  </svg>
</template>

<script>
export default {
  name: "DecastAnimatedLogo",
  data() {
    return {
      triggered: [false, false, false, false, false, false],
      isFadingOut: false,
      rects: [
        { x: 5,  y: 0,  w: 12, h: 6,  fill: '#D7DF23', dir: 'from-left' },
        { x: 17, y: 6,  w: 6,  h: 14, fill: '#D7DF23', dir: 'from-top' },
        { x: 5,  y: 20, w: 12, h: 6,  fill: '#D7DF23', dir: 'from-right' },
        { x: 17, y: 20, w: 6,  h: 14, fill: 'white',   dir: 'from-bottom' },
        { x: 23, y: 14, w: 12, h: 6,  fill: 'white',   dir: 'from-right' },
        { x: 23, y: 34, w: 12, h: 6,  fill: 'white',   dir: 'from-left' }
      ]
    };
  },
  mounted() {
    this.loopAnimation();
  },
  methods: {
    loopAnimation() {
      const delay = 500;
      const total = this.rects.length;

      this.isFadingOut = false;
      this.triggered = Array(total).fill(false);

      // Animate rects in one-by-one
      this.rects.forEach((_, i) => {
        setTimeout(() => {
          this.$set(this.triggered, i, true);
        }, i * delay);
      });

      const totalAnimationTime = total * delay;

      // Trigger fade-out for all rects after delay
      setTimeout(() => {
        this.isFadingOut = true;
        this.triggered = Array(total).fill(false);
      }, totalAnimationTime + 500); // wait 0.5s after last anim

      // Restart after fade-out
      setTimeout(() => {
        this.isFadingOut = false;
        this.loopAnimation();
      }, totalAnimationTime + 1200); // includes fade duration
    }
  }
};
</script>

<style scoped>
.enter {
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}

/* Fade out */
.fadeout {
  opacity: 0;
  transition: opacity 0.3s ease-out;
}

/* Directional entry */
.from-left.enter {
  animation-name: slide-left;
}
@keyframes slide-left {
  from { transform: translateX(-20px); }
  to   { transform: translateX(0); }
}

.from-right.enter {
  animation-name: slide-right;
}
@keyframes slide-right {
  from { transform: translateX(20px); }
  to   { transform: translateX(0); }
}

.from-top.enter {
  animation-name: slide-top;
}
@keyframes slide-top {
  from { transform: translateY(-20px); }
  to   { transform: translateY(0); }
}

.from-bottom.enter {
  animation-name: slide-bottom;
}
@keyframes slide-bottom {
  from { transform: translateY(20px); }
  to   { transform: translateY(0); }
}
</style>
